export default "/usdt-usdc.7868e03fed254397913af23771859083.svg";